<template>
    <Layout data-step="calc">
        <HomeSearchForm show-banner="true" />
    </Layout>
</template>

<script>
import Layout from '@/views/home/layout.vue'
import HomeSearchForm from '@/views/home/components/HomeSearchForm.vue'
export default {
    components: { Layout, HomeSearchForm },
}
</script>
